module.exports = __webpack_public_path__ + "static/media/open-new-tab.64c40b0d.svg";